import React from 'react';

const RelativesInfo = ({ relativesData, registrationAddress, residentialAddress }) => {
  
  const formatDate = (date) => {
    const rawDate = date.split('T')[0];
    const dateParts = rawDate.split('-');
    return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
  }

  return (
    <>
    <table style={{ marginTop: '20px' }}>
      <tbody>
        <tr>
          <th colSpan="5" className="bg">
            <p className="center b">Сведения о близких родственниках</p>
          </th>
        </tr>
        <tr>
            <th width={"15%"}><p className="center b">Степень родства</p></th>
            <th width={"17.5%"}><p className="center b">Ф.И.О.</p></th>
            <th width={"17.5%"}><p className="center b">Дата и место рождения</p></th>
            <th width={"25%"}><p className="center b">Должность и место работы</p></th>
            <th width={"25%"}><p className="center b">Адрес</p></th>
        </tr>
        {relativesData.map((relative, index) => (
          <tr key={index}>
            <td><p className='center'>{relative.RelationshipDegree.Name}</p></td>
            <td><p className='center'>{relative.Name}</p></td>
            <td><p>{relative.BirthPlace_Country.Name}<br/>{formatDate(relative.BirthDate)}</p></td>
            <td><p>{relative.Position}<br />{relative.WorkPlace}</p></td>
            <td><p>{relative.ResidencePlace}</p></td>              
          </tr>   
        ))}
      </tbody>
    </table>
    <table style={{ marginTop: '-1px' }} >
      <tbody>
        <tr>
          <td>
            <p className="b">Место прописки: {registrationAddress.ViewAddresses}</p>
          </td>
        </tr>
        <tr>
          <td>
            <p className="b">Место жительства: {residentialAddress.ViewAddresses}</p>
          </td>
        </tr>
      </tbody>
    </table>
    </>
  );
};

export default RelativesInfo;
